<!-- 
HomeLoanListDataTable.vue
功能：房貸精準行銷 DataTable
作者：i9400538 陳博承
完成：2022-06-10
-->
<template>
  <section class="newTable">
    <table class="table datatable table-striped area-list-datatable" id="HomeLoanListDataTable">
      <thead>
        <tr>
          <th id="th_sel" width="120">
            <div class="checkbox checkbox-inline mr-0">
              <input
                @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
                type="checkbox"
                name="check-all"
                id="check-all"
                value="1"
                v-model="checkAll"
              />
              <label for="check-all"></label>
            </div>
            <span>#</span>
          </th>
          <th
            id="th_name"
            class="text-center"
            :class="'sorting ' + (order.fieldName == 'name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('name')"
          >客戶姓名</th>
          <th
            id="th_id"
            class="text-center"
            :class="'sorting ' + (order.fieldName == 'id' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('id')"
          >客戶ID</th>
          <th
            id="th_mobile"
            class="text-center"
            :class="'sorting ' + (order.fieldName == 'mobile' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('mobile')"
          >客戶手機</th>
          <th
            id="th_address"
            width="300"
            class="text-center"
            :class="'sorting ' + (order.fieldName == 'address' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('address')"
          >客戶地址</th>
          <th class="text-center" id="th_visit" width="148">排訪</th>
        </tr>
      </thead>
      <tbody class="block-height" :style="{height: height + 'px'}">
        <tr v-for="(d, did) in tableDataBackup" :key="`HomeLoanListDataTable-table-td-${did}`">
          <td width="120">
            <div class="min-h-30">
              <div class="mr-0 checkbox checkbox-inline">
                <input
                  @click="clickTarget = clickTarget == `td-${did}`? `td-${did}-again`: `td-${did}`"
                  type="checkbox"
                  name="`td-item[]`"
                  :id="`HomeLoanListDataTable-check-${did}`"
                  :value="d.id"
                  v-model="selection"
                  :disabled="d.id === ''"
                  @change="$emit('update', selection)"
                />
                <label :for="`HomeLoanListDataTable-check-${did}`"></label>
              </div>
              <span>
                <span class="no">{{did + 1}}</span>
                <span class="info text-center">
                  <avatar :gender="Number(d.sex)" :size="20" />
                </span>
              </span>
            </div>
          </td>
          <td class="text-center">
            <Tooltip
              :position="did < 3?'bottom':'top'"
              :name="d.name"
              :id="d.id"
              :mobile="d.mobile"
              :address="d.address"
            >
              <a
                v-if="d.c111_id"
                class="text-green text-underline pointer-cursor"
                @click="routerToCust(d.id, d.name)"
              >{{d.name | getMaskName}}</a>
              <a v-else>{{d.name | getMaskName}}</a>
            </Tooltip>
          </td>
          <td class="text-center">{{d.id | getMaskID}}</td>
          <td class="text-center">{{d.mobile | getMaskMobile}}</td>
          <td class="text-center" width="300">{{d.address | getMaskAddress}}</td>
          <!--排訪-->
          <td v-if="isBox" class="text-center" :width="iPadWidth">
            <button
              v-if="!d.visit.csidno"
              type="button"
              class="btn btn-primary"
              @click="callBoxVisit(d)"
              v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"
            ></button>
            <button
              v-else
              type="button"
              class="btn btn-primary"
              style="font-size:0.8rem;"
              @click="callBoxVisit(d)"
            >
              {{ d.visit.str_date | dateFormat }}
              <br />
              {{ d.visit.str_time }}
            </button>
          </td>
          <td v-else class="text-center" :width="iPadWidth">
            <button
              v-if="!d.visit.csidno"
              type="button"
              class="btn btn-primary"
              @click="$emit('scheduled-access', d)"
              v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"
            ></button>
            <button
              v-else
              type="button"
              class="btn btn-primary"
              style="font-size:0.8rem;"
              @click="$emit('scheduled-access', d)"
            >
              {{ d.visit.str_date | dateFormat }}
              <br />
              {{ d.visit.str_time }}
            </button>
          </td>
        </tr>
        <tr v-if="tableDataBackup.length == 0">
          <td colspan="6" class="text-center pt-3 pb-5">
            <h3>無客戶名單資料</h3>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Avatar from "@/components/Avatar";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
import Tooltip from "@/desktop/components/ToolTip";
import { doSortList } from "@/service";

const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad
let idmarkWidth = 148;
if (is_iPad) {
  idmarkWidth = 131;
}

export default {
  name: "HomeLoanListDataTable",
  mixins: [commonMixin],
  components: { Avatar, Tooltip },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    height: {
      type: Number,
      default: () => {
        return 350;
      }
    },
    //名單專區資訊
    categoryInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      order: {
        fieldName: "name",
        asc: true
      },
      checkAll: false,
      clickTarget: "",
      tableDataBackup: [],
      allIdData: [],
      selection: [],
      currentWidth: 0,
      is_iPad: is_iPad,
      iPadWidth: idmarkWidth
    };
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === "box";
    }
  },
  watch: {
    tableData: function() {
      this.init();
    },
    clickTarget: function(target) {
      if (target == "clickAll" || target == "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.allIdData.forEach(data => {
            this.selection.push(data);
          });
        } else {
          //取消全選
          this.selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.allIdData.length;
      }
      this.$emit("update", this.selection);
    }
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    columnSorting(fieldName) {
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.fieldName = fieldName;
        this.order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }
      switch (fieldName) {
        case "name":
          //依照姓名筆劃排序
          if (this.tableDataBackup && this.tableDataBackup.length) {
            this.$emit("changeLoading", true); //開啟遮罩
            doSortList(
              this.$store.state.userInfo.id,
              sortOrder == 1 ? "1" : "-1",
              this.tableDataBackup,
              fieldName
            ).then(result => {
              this.$emit("changeLoading", false); //關閉遮罩
              if (result.header && result.header.status === "200") {
                this.tableDataBackup = result.body.result;
                this.registerHanlink(); //難字顯示
              } else {
                if (result.header && result.header.message) {
                  this.$toast.info({ title: result.header.message });
                } else {
                  this.$toast.info({ title: "姓名排序異常,請重新操作" });
                }
              }
            });
          }
          break;
        default:
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.sortCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // for 難字更新
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    routerToCust(custID, custName) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(custID, custName);
      } else {
        this.updateCustID(custID);
        localStorage.CustID = custID;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    init() {
      this.checkAll = false;
      this.selection = [];
      this.tableDataBackup = this.tableData.map(ele => {
        return ele;
      });
      this.allIdData = this.tableData.map(ele => {
        return ele.id;
      });
      //預設用客戶地址排序
      this.order.fieldName = "address";
      this.order.asc = false;
      this.columnSorting("address");
      this.registerHanlink(); // for hard word
    },
    //連至Box排訪
    callBoxVisit(data) {
      this.boxVisit(data, this.categoryInfo);
    },
    //回傳當前排序資料集
    getSortedList() {
      return this.tableDataBackup;
    }
  },
  mounted() {
    this.currentWidth =
      this.$el.clientWidth * (this.$el.clientWidth < 1250 ? 0.95 : 1);
    if (!is_iPad) {
      this.iPadWidth = "131";
    } else {
      this.iPadWidth = "148";
    }
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

.text-center {
  text-align: center;
}
</style>
